module.exports = __webpack_public_path__ + "static/media/IconSend.84712998.svg";